'use strict';

const component = angular.module('dash.nav.left.measurements.item', ['ngSanitize']);

component.controller('MeasurementItemController', require('./MeasurementItemController'));
component.directive('measurementsItem', require('./MeasurementItemDirective'));



// WEBPACK FOOTER //
// ./src/app/dash/nav/navLeft/measurements/item/index.js